import { makeObservable, observable } from "mobx";
import { TableStore } from "../TableStore";
import { ColumnsType } from "../types";
import { BaseRowStore } from "../row/BaseRowStore"
import { _ } from "ynf-core-middleware";
import { convertField } from '../../common'
import { HeaderColumns } from "./HeaderColumns";

const mobxReg = /^mobx:\/\//

export class BaseColumn {
  // tableStore
  tableStore: TableStore;
  // 禁用
  disabled?: boolean;
  // 显示
  visible?: boolean;
  // 只读
  readOnly?: boolean;
  // 必填
  required?: boolean;
  dataIndex?: number;
  // 默认值
  defaultValue?: string | object;
  // 列类型
  controlType?: string;
  // 标题
  caption?: string;
  storeAlias: string;
  field: string | undefined;
  // 是否隐藏字段
  virtualField?: boolean;
  // 特征
  characterId?: string;
  // 特征
  stateType?: string;
  bizType?: string;
  tableHeader?: any
  fieldDesc?: any
  constructor(column: ColumnsType, tableStore: TableStore) {
    this.fieldDesc = column
    this.defaultValue = column.defaultValue;
    this.required = undefined;
    this.readOnly = undefined;
    this.disabled = undefined;
    this.visible = undefined;
    this.dataIndex = column.dataIndex;
    this.caption = column.caption;
    this.storeAlias = column.storeAlias;
    this.bizType = column.bizType
    this.controlType = column.controlType;
    this.tableStore = tableStore;
    this.virtualField = column.virtualField;
    this.characterId = column.characterId;
    this.stateType = column.stateType
    this.field = this.autoFieldPretreatment(column.field)
    this.tableHeader = new HeaderColumns(column.tableHeader, this)
    makeObservable(this, {
      defaultValue: observable,
      required: observable,
      readOnly: observable,
      disabled: observable,
      visible: observable,
      dataIndex: observable,
      caption: observable,
      storeAlias: observable,
      field: observable,
      controlType: observable,
      tableStore: observable,
      virtualField: observable,
    });
  }
  protected getColumn(key: string) {
    return this.tableStore.getColumn(key)
  }
  getFieldByStoreAlias(storeAlias: string) {
    const column = this.getColumn(storeAlias)
    return column?.getField() || storeAlias
  }

  /**
   * 获取真实与后端交互数据(参照在获取值的时候getValue(xxxId)拿到的是个{id:xx,name:xx})
   * @param storeAlias key
   * @param row BaseRowStore
   * @returns 
   */
  getEntityValue(storeAlias: string, row: BaseRowStore<any>) {
    return row?.getTrueValue(storeAlias)
  }
  /**
 *
 * @param field 参照带入值是一个普通的字段，store配置的field是 aaa.bbb 这种形式，但是后端返回的数据是 aaa_bbb这种形式
 * @returns
 */
  private autoFieldPretreatment(field?: string) {
    if (this.bizType == 'quote' && field) {
      return convertField(field, !this.isCharacter())
    }
    if (this.stateType && !field) {
      return this.storeAlias
    }
    return field
  }

  isCharacter() {
    return !!(this.characterId || this.stateType)
  }
  /**
   *  当没有配置 field的时候，确保能够正常运行。
   * @returns
   */
  getField() {
    return this.field || this.storeAlias
  }

  setReadOnly(readOnly: boolean) {
    this.readOnly = readOnly;
  }

  setDisabled(disabled: boolean) {
    this.disabled = disabled;
  }

  setVisible(visible: boolean) {
    this.visible = visible;
  }

  setRequired(required: boolean) {
    this.required = required;
  }

  setValue(value: any, row: BaseRowStore<any>) {
    row.setTrueValue(this.getField(), value, this.isCharacter());
  }

  getValue(row: BaseRowStore<any>) {
    return row.getTrueValue(this.getField());
  }
  get value() {
    return (row: BaseRowStore<any>) => row.getTrueValue(this.getField());
  }

  //解析mobx
  getMobxProperty = (property: any) => {
    return typeof (property) === 'string' && mobxReg.test(property)
      ? eval(property.replace(mobxReg, ''))
      : property
  }
  validator = () => {
    return this.isRequired ? [['required']] : []
  }

  get isRequired() {
    return this.required !== undefined ? this.required : this.tableHeader?.isRequired
  }
  get isVisible() {
    return this.visible !== undefined ? this.visible : this.tableHeader?.isVisible;
  }
  get isDisabled() {
    return this.disabled !== undefined ? this.disabled : this.tableHeader?.isDisabled
  }
  get isReadOnly() {
    return this.readOnly !== undefined ? this.readOnly : this.tableHeader?.isReadOnly
  }
}
